import { createContext, useContext, useState, useCallback } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const addItem = useCallback((beat, licenseTier) => {
    setItems((prev) => {
      const exists = prev.find(
        (i) => i.beat.id === beat.id && i.licenseTier === licenseTier
      );
      if (exists) return prev;
      return [...prev, { beat, licenseTier, price: beat.pricing[licenseTier] }];
    });
  }, []);

  const removeItem = useCallback((beatId, licenseTier) => {
    setItems((prev) =>
      prev.filter((i) => !(i.beat.id === beatId && i.licenseTier === licenseTier))
    );
  }, []);

  const clearCart = useCallback(() => setItems([]), []);
  const openCart = useCallback(() => setIsOpen(true), []);
  const closeCart = useCallback(() => setIsOpen(false), []);

  const total = items.reduce((sum, i) => sum + i.price, 0);
  const itemCount = items.length;

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, clearCart, total, itemCount, isOpen, openCart, closeCart }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
